import accountDetailsCard from './account_details_card.json';
import customerBillsCard from './customer_bills_card.json';
import mobileNumberCard from './mobile_number_card.json';
import welcomeCard from './welcome_card.json';
import type { A2uiSurface } from '@/types/a2ui';

type CatalogDefinition = Omit<A2uiSurface, 'dataModel'> & {
  componentName: string;
};

const catalogs: Record<string, CatalogDefinition> = {
  AccountDetailsCard: accountDetailsCard as unknown as CatalogDefinition,
  CustomerBillsCard: customerBillsCard as unknown as CatalogDefinition,
  MobileNumberCard: mobileNumberCard as unknown as CatalogDefinition,
  WelcomeCard: welcomeCard as unknown as CatalogDefinition,
};

export function createCatalogSurface(componentName: string, dataModel: Record<string, unknown> = {}): A2uiSurface | undefined {
  const catalog = catalogs[componentName];
  if (!catalog) return undefined;

  return {
    componentId: catalog.componentName,
    catalogId: catalog.catalogId,
    components: catalog.components,
    dataModel,
  };
}